import LandingPageForm from '../components/LandingPageForm';

export default function SanMarinoLandingPage() {
  return (
    <LandingPageForm 
      cityName="San Marino"
      neighborhood="San Marino"
      sourceTag="qr-sanmarino-mailer"
    />
  );
}
